import { OrderByInput, useExportAssets } from '@gripp/shared-logic';
import { ColumnDef } from '@tanstack/react-table';
import { useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { Pressable, StyleSheet } from 'react-native';
import { Colors } from '../../themes/colors';
import { SaveIcon } from '../crop-circle/icons/saveIcon';

type ExportButtonProps = {
  fileName: string;
  query: any;
  filter: any;
  orderBy: OrderByInput;
  dataPrefix: string;
  columns: ColumnDef<any, any>[];
};

export const DataGridExportButton = (props: ExportButtonProps) => {
  const csvRef = useRef<any>(null);
  const [download, toggleDownload] = useState(false);

  const onDataReady = () => {
    if (download) {
      doDownload();
    }
  };

  const { headers, rows, isLoading } = useExportAssets({
    query: props.query,
    filter: props.filter,
    orderBy: props.orderBy,
    dataPrefix: props.dataPrefix,
    columns: props.columns,
    download: download,
    onDataReady: onDataReady,
  });

  const doDownload = () => {
    setTimeout(() => {
      csvRef.current?.link.click();
      toggleDownload(false);
    }, 50);
  };

  const onDownload = () => {
    toggleDownload(true);
  };

  return (
    <>
      <Pressable
        onPress={onDownload}
        disabled={isLoading}
        style={baseStyles.icon}
      >
        <SaveIcon
          size={20}
          color={isLoading ? Colors.role.fillDisabled : Colors.role.textPrimary}
        />
      </Pressable>
      <CSVLink
        data={rows}
        headers={headers}
        filename={`${props.fileName}.csv`}
        ref={csvRef}
      />
    </>
  );
};

const baseStyles = StyleSheet.create({
  icon: {
    margin: 0,
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
